/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Import_SuccessInputs */

const en_ad_import_success = /** @type {(inputs: Ad_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD project imported successfully. Three Event Groups have been added: Dialogue, Shot Changes, and AD Template.`)
};

const fr_ad_import_success = /** @type {(inputs: Ad_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projet AD importé avec succès. Trois groupes d'événements ont été ajoutés : Dialogue, Changements de plan et Modèle AD.`)
};

const de_ad_import_success = /** @type {(inputs: Ad_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das AD-Projekt wurde erfolgreich importiert. Drei Ereignisgruppen wurden hinzugefügt: Dialog, Szenenwechsel und AD-Vorlage.`)
};

const it_ad_import_success = /** @type {(inputs: Ad_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progetto AD importato correttamente. Sono stati aggiunti tre gruppi di eventi: Dialogo, Cambi di inquadratura e Modello AD.`)
};

const ru_ad_import_success = /** @type {(inputs: Ad_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект AD успешно импортирован. Добавлены три группы событий: Диалог, Смена кадров и Шаблон AD.`)
};

const es_ad_import_success = /** @type {(inputs: Ad_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El proyecto de AD se importó correctamente. Se han añadido tres grupos de eventos: Diálogo, Cambios de plano y Plantilla de AD.`)
};

const zh_cn2_ad_import_success = /** @type {(inputs: Ad_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD项目导入成功。已添加三个事件组：对话、镜头切换和AD模板。`)
};

const ja_ad_import_success = /** @type {(inputs: Ad_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADプロジェクトが正常にインポートされました。ダイアログ、ショット変更、ADテンプレートの3つのイベントグループが追加されました。`)
};

const hi_ad_import_success = /** @type {(inputs: Ad_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विज्ञापन परियोजना सफलतापूर्वक आयात हो गई है। तीन इवेंट समूह जोड़े गए हैं: संवाद, शॉट परिवर्तन और विज्ञापन टेम्पलेट।`)
};

const pt_pt2_ad_import_success = /** @type {(inputs: Ad_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto AD importado com sucesso. Três Grupos de Eventos foram adicionados: Diálogo, Mudanças de Plano e Modelo AD.`)
};

/**
* | output |
* | --- |
* | "AD project imported successfully. Three Event Groups have been added: Dialogue, Shot Changes, and AD Template." |
*
* @param {Ad_Import_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_import_success = /** @type {((inputs?: Ad_Import_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Import_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_import_success(inputs)
	if (locale === "de") return de_ad_import_success(inputs)
	if (locale === "it") return it_ad_import_success(inputs)
	if (locale === "ru") return ru_ad_import_success(inputs)
	if (locale === "es") return es_ad_import_success(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_import_success(inputs)
	if (locale === "ja") return ja_ad_import_success(inputs)
	if (locale === "hi") return hi_ad_import_success(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_import_success(inputs)
	return en_ad_import_success(inputs)
});